// Only the two countries the product actually operates in are mapped: the
// country select stores alpha-3 codes, and the server accepts both forms
// (2 or 3 latin letters). Anything else is passed through lower-cased, so the
// column holds alpha-2 for RU/KG and alpha-3 for the rest — widening this means
// building the map from the countries dictionary, which already carries alfa2.
const alpha3ToAlpha2CountryCodes: Record<string, string> = {
  KGZ: 'kg',
  RUS: 'ru',
};

export const toCanonicalCountryCode = (countryCode: string | undefined) => {
  const normalized = countryCode?.trim();
  if (!normalized) {
    return undefined;
  }

  return alpha3ToAlpha2CountryCodes[normalized.toUpperCase()] ?? normalized.toLowerCase();
};
